import { ThemeLayout } from '../components/theme/theme-layout';
import { TrialExpiredCta } from '../components/trial-expired-cta';

function TrialExpired() {
  return (
    <ThemeLayout variant="centered">
      <TrialExpiredCta />
    </ThemeLayout>
  );
}

export default TrialExpired;
